var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"LoadingPage",class:_vm.rootClasses},[_c('div',{staticClass:"Center"},[_c('Circular',{attrs:{"size":"medium"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }